(() => {
  const gate = document.getElementById('MoleculeAgeGate');
  if (!gate) return;

  const COOKIE_NAME = 'mollecule_research_access';
  const form = gate.querySelector('.molecule-age-gate__form');
  const enter = gate.querySelector('.molecule-age-gate__enter');
  const decline = gate.querySelector('.molecule-age-gate__decline');
  const frequency = gate.dataset.frequency || 'daily';
  const designMode = gate.dataset.designMode === 'true';
  const shopHost = 'shopmollecule.com';

  function landingRequiresAgeGate() {
    try {
      return new URLSearchParams(location.search).get('age_gate') === '1';
    } catch {
      return false;
    }
  }

  function cameFromShopLanding() {
    if (designMode || landingRequiresAgeGate()) return false;

    try {
      const referrer = document.referrer;
      if (!referrer) return false;
      const host = new URL(referrer).hostname.replace(/\.$/, '').toLowerCase();
      return host === shopHost || host.endsWith(`.${shopHost}`);
    } catch {
      return false;
    }
  }

  function stripAgeGateParam() {
    try {
      const url = new URL(location.href);
      if (url.searchParams.get('age_gate') !== '1') return;
      url.searchParams.delete('age_gate');
      history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
    } catch {
      // Ignore malformed URLs. The gate still works without rewriting the address.
    }
  }

  function hasConsent() {
    if (designMode) return false;

    if (frequency === 'daily') {
      return document.cookie
        .split('; ')
        .some((entry) => entry.startsWith(`${COOKIE_NAME}=`));
    }

    try {
      return sessionStorage.getItem(COOKIE_NAME) === 'accepted';
    } catch {
      return false;
    }
  }

  function rememberConsent() {
    if (frequency === 'daily') {
      const secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = `${COOKIE_NAME}=accepted; Max-Age=86400; Path=/; SameSite=Lax${secure}`;
      return;
    }

    try {
      sessionStorage.setItem(COOKIE_NAME, 'accepted');
    } catch {
      // Storage can be unavailable in privacy-restricted browser contexts.
    }
  }

  function dismiss() {
    document.documentElement.classList.remove('molecule-age-gate-pending');
    document.body.classList.remove('molecule-age-gate-open');
    gate.close();
  }

  function show() {
    document.documentElement.classList.add('molecule-age-gate-pending');
    document.body.classList.add('molecule-age-gate-open');
    if (!gate.open) gate.showModal();
    enter?.focus({ preventScroll: true });
  }

  gate.addEventListener('cancel', (event) => {
    event.preventDefault();
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    rememberConsent();
    stripAgeGateParam();
    dismiss();
  });

  decline.addEventListener('click', () => {
    const destination = gate.dataset.declineUrl || 'https://www.google.com';
    window.location.assign(destination);
  });

  const fromShop = cameFromShopLanding();
  const forceGate = landingRequiresAgeGate();

  if (!forceGate && (hasConsent() || fromShop)) {
    if (fromShop) rememberConsent();
    gate.remove();
    document.documentElement.classList.remove('molecule-age-gate-pending');
  } else {
    show();
  }
})();
